export const listUrl = '/department/list'
export const createUrl = '/department/create'
export const updateUrl = '/department/update'
export const deleteUrl = '/department/delete'
export const exportUrl = '/department/export'
export const obdListUrl = '/department/{0}/obd/list'
export const obdUnauthorizedListUrl = '/department/{0}/obd/unauthorized/list'
export const addObdUrl = '/department/{0}/obd'
export const deleteObdUrl = '/department/{0}/obd'

export const resetPwdUrl = '/company/reset/{0}'
export const importObdUrl = process.env.VUE_APP_BASEURL + '/department/{0}/obdBindingImport'
export const exportObdUrl = '/department/obdBindingExport'
